import { get_testing_type, get_testing_list, get_testing_schedule_list } from './restapi';

const parseDate = (value) => {
  if (!value) return null;
  const normalized = String(value).replace(/\./g, '-').replace(/\//g, '-').trim();
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return null;
  date.setHours(0, 0, 0, 0);
  return date;
};

/**
 * 정기시험 유형과 '이번 회차' 시험 1건을 찾는다.
 * 시험일정 기준으로
 *   1) 진행 중(시작일 <= 오늘 <= 종료일) 시험을 최우선 선택
 *   2) 없으면 오늘 이후(미실시) 중 가장 임박한 시험
 *   3) 없으면 오늘 이전(실시됨) 중 가장 최근 시험
 */
export const getCurrentRegularTesting = async () => {
  const response = await get_testing_type();
  const types = response || [];

  const regularType = types.find((type) => {
    const name = `${type?.nickname || ''}${type?.name || ''}`;
    return name.includes('정기');
  }) || null;

  if (!regularType?.code) {
    return { types, regularType: null, testing: null };
  }

  const testingResponse = await get_testing_list({
    type: regularType.code,
    page: 1,
    rowsPerPage: 1000,
    sort: 'a_testing_id',
    desc: 'desc'
  });

  const regularTestings = testingResponse?.lists || testingResponse || [];
  if (!regularTestings.length) {
    return { types, regularType, testing: null };
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  let inProgress = null;
  let nearestUpcoming = null;
  let latestPast = null;
  const candidates = regularTestings.slice(0, 100);

  for (const testing of candidates) {
    try {
      const scheduleResponse = await get_testing_schedule_list({
        testing_id: testing.testing_id,
        page: 1,
        rowsPerPage: 1000,
        sort: 'a_testStopDate',
        desc: 'desc'
      });

      const schedules = scheduleResponse?.lists || scheduleResponse || [];
      for (const schedule of schedules) {
        const startDate = parseDate(schedule?.testStartDate || schedule?.startDate || schedule?.testStopDate || schedule?.stopDate);
        const stopDate = parseDate(schedule?.testStopDate || schedule?.stopDate || schedule?.testStartDate || schedule?.startDate);
        if (!startDate || !stopDate) continue;

        const isInProgress = startDate <= today && today <= stopDate;
        if (isInProgress) {
          if (!inProgress || stopDate < inProgress.date) {
            inProgress = { testing, date: stopDate };
          }
          continue;
        }

        if (stopDate >= today) {
          if (!nearestUpcoming || stopDate < nearestUpcoming.date) {
            nearestUpcoming = { testing, date: stopDate };
          }
        } else {
          if (!latestPast || stopDate > latestPast.date) {
            latestPast = { testing, date: stopDate };
          }
        }
      }
    } catch (error) {
      console.error('Error fetching testing schedule:', error);
    }
  }

  const testing = inProgress?.testing || nearestUpcoming?.testing || latestPast?.testing || regularTestings[0];

  return { types, regularType, testing };
};
